module.exports = __webpack_public_path__ + "static/universal_particles-d794cc9d3c2ba6caff9e60753baa1bdf.png";